interface JsonLdProps {
  data: object | object[]
}

/**
 * Renders JSON-LD structured data into the prerendered HTML.
 * Data is generated by typed builders in src/seo/schema/.
 */
export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data).replace(/</g, "\\u003c"),
      }}
    />
  )
}
